// Turkish

export default {
  component: {

    supportLink: 'support@recright.com',

    layout: {
      endTime: date => (date ? `Şu tarihe kadar açık ${date}` : ''),
    },
    interview: {
      title: 'Video mülakatı cevapla',
      submit: 'Cevapları gönder ve mülakatı tamamla',
      continueLater: 'Daha sonra devam et',
      startInterview: 'Mülakata başla',
      duplicateError: 'Bu mülakata zaten katıldınız. Daha önce, invitations@recright.com adresinden, mülakata devam etmek için kullanabileceğiniz bir link içeren bir e-posta aldınız.',
      confirmSubmitHeader: 'Mülakat sorularının tümünü cevaplamadınız',
      confirmSubmitContent: 'Mülakatı gerçekten sonlandırmak istiyor musunuz?',
      confirmSubmitContentWarning: 'Bundan sonra cevaplarınızı dolduramazsınız.',
      submitInterviewHeader: 'Röportaj yanıtlarınızı gönderin',
      submitInterviewContent: 'Röportajınızı göndermek istediğinizden emin misiniz?',
      confirmSubmitButton: 'Cevapları gönder ve mülakatı tamamla',
      preview: 'Video sorularını buradan görüntüleyebilirsiniz.',
      requiredQuestionsNotAnswered: 'Lütfen göndermeden önce tüm zorunlu soruları cevaplayın.',

      withdrawLink: 'Bu pozisyonla artık ilgilenmiyor musunuz? Buraya tıklayarak süreçten ayrılın.',
    },

    personalInterview: {
      title: 'Toplantı için uygun bir zaman seçin',
      description: [
        'Bir toplantıya davet edildiniz.',
        'Lütfen size en uygun zamanı seçin.',
      ],
      position: 'Pozisyon:',
      location: 'Yer:',
      time: 'Saat:',
      timezoneNotice: [
        'Not: Saatler sizin saat diliminizde gösterilmektedir.',
        'Saat diliminiz şu şekilde görünüyor:',
        'Randevu saat dilimi:',
      ],
      success: {
        title: 'Her şey hazır!',
        description: 'Harika! Bir toplantı planladınız!! Toplantı bilgileriniz:',
        linkDescription: [
          'Etkinliği takviminize aşağıdan ekleyebilirsiniz.',
          'Veya linki takvim uygulamanıza kopyalayabilirsiniz:',
        ],
        link: 'Takviminize ekleyin',
      },
    },

    interviewForm: {
      name: 'Ad',
      city: 'Yaşadığı yer',
      email: 'E-posta',
      phone: 'Telefon numarası',
      link: 'Bağlantı',
      legendBasicInfo: 'Temel bilgiler',
      placeholderName: 'Adınızı girin',
      placeholderEmail: 'E-posta adresinizi girin',
      placeholderPhone: 'Telefon numaranızı girin',
      placeholderCity: 'Şu anda yaşadığınız yeri girin',
      placeholderLink: 'Link ekleyin, örneğin LinkedIn profiliniz.',
      legendAttachments: 'Ekler',
      legendAdditionalFields: 'Ek bilgi',
      required: '* (yıldız işareti) ile işaretlenmiş öğeler zorunludur.',
    },

    sequencedInterview: {
      networkTest: {
        audio: 'Ses',
        video: 'Video',
        yes: 'Evet',
        no: 'Hayır',
        supported: 'Destekleniyor',
        quality: 'Kalite',
        header: 'Ağ bağlantısı ve cihaz testi',
        description: 'Şimdi, ağ bağlantınızın ve mülakat için gereken donanımınızın (kamera ve mikrofon) düzgün çalıştığından emin olmak için bir test yapacağız. İstendiğinde, lütfen testin hem kameranızı hem de mikrofonunuzu kullanmasına izin verin ve kameranızın üzeri örtülerek kapatılmadığından emin olun. Test yaklaşık 30 saniye sürecektir. Donanım testi sırasında konuşmanızı öneririz.',
        inProgress: 'Test yapılıyor...',
        networkTestResults: 'Ağ testi sonuçları',
        qualityTestResults: 'Kalite testi sonuçları',
        testPassedNetwork: 'Ağ testi başarılı',
        testFailedNetwork: 'Ağ testi başarısız',
        testPassedQuality: 'Kalite testi başarılı',
        testFailedQuality: 'Kalite testi başarısız',
        startTest: 'Testi başlat',
        startInterview: 'Mülakatı başlat',
        testAgain: 'Testi tekrarla',
        confirmTitle: 'Mülakatınıza başlamak üzeresiniz',
        confirmWarning: 'Video mülakatınız başladığında, otomatik olarak ilk mülakat sorunuzu görüntülemeye yönlendirilirsiniz. Soruyu görüntüledikten sonra hazırlanma aşamasına geçeceksiniz.',
        confirmText: 'Her sorudan önce cevabınızı hazırlamak için kısa bir süreniz olacaktır. Hazırlanma aşamasından sonra soruyu cevaplamak için önceden belirlenmiş bir süreniz olacaktır. Hazır olduğunuzda, önceden belirlenmiş cevaplama süresi henüz dolmuş olmasa bile cevabınızı gönderebilirsiniz.',
        confirmText2: 'Cevabınızı gönderdikten sonra bir sonraki soruya yönlendirilirsiniz ve tüm sorular tamamlanana kadar böyle devam eder.',
        confirmText3:
          'Not: Lütfen bir soruya verdiğiniz cevabı kaydettikten sonra o sorunun cevabını düzenlemeye izin veriliyorsa cevabınızı düzenlemek için 30 saniyelik bir süreniz olacağını unutmayın. Bu 30 saniyelik süre zarfında cevabınızı düzenlemeye başlamazsanız mevcut cevabınız otomatik olarak gönderilir ve bir sonraki soruya geçilir.',
        goodLuck: 'Derin bir nefes alın ve sakin olun. İyi şanslar!',
        qualityRating: {
          excellent: 'Mükemmel',
          good: 'İyi',
          fair: 'Orta',
          poor: 'Zayıf',
          bad: 'Kötü',
        },
      },
      questionAnswerView: {
        title: title => `${title} adlı mülakatı cevaplayın`,
        question: 'Soru',
        submitAndNext: 'Gönder ve Sonrakine Geç',
        submitAndFinish: 'Mülakatı Gönder ve Sonlandır',
        submitSuccess: 'Video başarıyla gönderildi!',
        skipText: 'Kaydı başlat',
        stop: 'Durdur',
        retake: 'Tekrar kaydet',
        take: 'Kaydet',
        takesLeft: 'Kalan kayıt sayısı',
        skipTextQuestion: 'Hazır mısınız? İlerleyin',
        retakeConfirmTitle: 'Bu soruya verdiğiniz cevabı düzenlemek istediğinizden emin misiniz?',
        retakeConfirmSubmit: 'Evet, düzenlemeyi başlat',
        submitInfoForward: 'Mevcut cevabınızın otomatik olarak gönderilmesine ve sonraki soruya geçilmesine kalan süre:',
        submitInfoForward2: 'saniye',
        nonAnswerableText: 'Bu mesaj yanıt gerektirmiyor. Bu mesajın ardından, doğrudan bir sonraki soruya yönlendirileceksiniz.',
        nonAnswerableVideo: 'Bu video yanıt gerektirmiyor. Bu videonun ardından, doğrudan bir sonraki soruya yönlendirileceksiniz.',
        answerTimeInfo: (answerMinutes, answerSeconds) =>
          `Soruyu yanıtlamak için ${answerMinutes} dakika ${answerSeconds} saniyeniz var.`,
      },
      publisher: {
        toNextQuestion: timer => `${timer} içinde sonraki soruya geçilecek`,
        recordingStarts: timer => `Kayıt ${timer} içinde başlayacak`,
      },
      errors: {
        tooManyConnections: 'Şu anda başka bir sekmede veya pencerede açık bir bağlantınız olduğu için, bu bağlantı kapatıldı.',
        unsupportedBrowser: 'Maalesef bu işlem tarayıcınızda desteklenmiyor. Lütfen farklı bir tarayıcı kullanın.',
        networkError: 'İnternet bağlantısı yok.',
        reconnecting: 'Bağlantı kesildi. Yeniden bağlantı deneniyor.',
        generalError: 'Bir hata oluştu. Lütfen sayfayı yenileyip tekrar deneyin.',
        allowMediaDevicesError: 'Bu işlem ortam cihazlarını (kamera veya mikrofon) algılayamadı. Lütfen tarayıcının kameranızı ve mikrofonunuzu kullanmasına izin verdiğinizden emin olun.',
        noAvailableDevicesError: 'Kamera veya mikrofon bulunamadı. Lütfen tarayıcının kameranızı ve mikrofonunuzu kullanmasına izin verdiğinizden ve bunların başka bir uygulama tarafından kullanılmadığından emin olun ve ardından tekrar deneyin.',
        initPublisherError: 'İşlem, bir hata nedeniyle başarısız oldu. Lütfen tarayıcının kameranızı ve mikrofonunuzu kullanmasına izin verdiğinizden ve bunların başka bir uygulama tarafından kullanılmadığından emin olun ve ardından tekrar deneyin.',
      },
      browserInfo: {
        browserSupportTitle: 'Tarayıcı desteği',
        supportedBrowsers: 'Bu test ve mülakat, Chrome, Firefox, Safari ve Edge\'in en son sürümlerini desteklemektedir.',
        mobileSupported: 'Mobil cihazlarda desteklenen tarayıcılar',
        android: 'Android: Google Chrome (son sürüm), Firefox (son sürüm)',
        iOS: 'iOS: Safari (son sürüm)',
        latestVersion: 'Lütfen tarayıcınızın son sürümünü kullandığınızdan emin olun. Bu, her şeyin sorunsuz çalıştığından emin olmak içindir.',
        freezeInstruction: 'Video kaydı başlamazsa veya kayıt ekranı siyah kalırsa, lütfen sayfayı yenileyin.',
        unsupportedOnIos: 'iOS\'ta desteklenmeyen bir tarayıcı kullandığınızı tespit ettik. Lütfen Safari\'yi kullanın.',
        ieUnsupported: 'Internet Explorer kullandığınızı tespit ettik. Üzgünüz, fakat bu test veya mülakat Internet Explorer’ı desteklemiyor. Lütfen farklı bir tarayıcı kullanın.',
        qualityTestNotSupported: 'Üzgünüz, fakat donanım testi, kullandığınız tarayıcıda desteklenmiyor. Ses ve görüntü kalitesini test etmeden mülakata devam edebilir veya alternatif olarak farklı bir tarayıcı kullanabilirsiniz.',
      },
      reconnectSuccess: 'Yeniden bağlantı başarılı!',
      continue: 'Devam et',
    },

    withdraw: {
      title: 'Bu pozisyonla artık ilgilenmiyor musunuz?',
      description: 'İşe alım sürecinden ayrılın.',
      buttonText: 'İşe alım sürecinden ayrıl',
      thankYouTitle: 'Teşekkürler!',
      thankYouText: 'İşe alım sürecinden ayrıldınız.',
      confirm: 'İşe alım sürecinden ayrılmak istediğinizden emin misiniz? Ayrıldıktan sonra bu mülakatı veya bu pozisyonla ilgili başka herhangi bir mülakatı artık cevaplayamazsınız.',
    },
  },

  page: {
    embeddedProfileInterview: {
      submit: 'Gönder',
      continue: 'Devam et',
      supportCenter: 'Recright Help Center',
      thankYou:
        'Videolu yanıtlarınız için teşekkür ederiz! Yakında sizinle iletişime geçeceğiz!',
    },

    supportLink: 'support@recright.com',

    finished: {
      reopenDescription: 'Bu mülakatı yanlışlıkla kapattıysanız, endişe etmeyin! Aşağıdaki düğmeye tıklayarak mülakatı yeniden açabilirsiniz!',
      reopenButtonText: 'Mülakatı yeniden aç',
      title: 'Mülakata katıldığınız için teşekkür ederiz!',
      description1: 'Harika! Tüm mülakat sorularını cevapladınız ve cevaplarınız işe alım birimine gönderildi. Takipte kalın!',
      descriptionsupport: mailto => `Bu mülakatı yanlışlıkla kapattıysanız, endişe etmeyin! ${mailto} üzerinden Müşteri Destek birimimiz ile iletişime geçerek mülakatın yeniden açılmasını talep edebilirsiniz.`,
      descriptionfeedback: 'Deneyiminiz bizim için çok önemli! Video mülakat sorularını cevaplarken neler hissettiğinizi bilmek isteriz. Hizmetlerimizi nasıl iyileştirebiliriz? Görüşlerinizi buradan paylaşabilirsiniz:',
      feedbackbutton: 'Görüşlerinizi paylaşın',
      regularUrl: 'https://www.surveymonkey.com/r/B3ZCSWT',
      timedUrl: 'https://www.surveymonkey.com/r/MZMLPPT',
    },
    messages: {
      title: 'Kişisel mesaj',
    },

    closed: {
      title: 'Mülakat tamamlandı veya mülakat sona erdi',
      description: 'Davet edildiğiniz video mülakat sona erdi veya gönderme işleminizi tamamladınız.',
      publicTitle: 'Mülakat sona erdi',
      publicDescription: 'Aradığınız video mülakat sona erdi.',
    },
    saved: {
      title: 'Video mülakatınız şimdi kaydedildi!',
      description: 'Daha önce e-postanıza gönderilen linki kullanarak video mülakata kaldığınız yerden devam edebilirsiniz. Geri döndüğünüzde, kaydedilmiş olan video cevapları yerinde olacaktır! İş aramada iyi şanslar!',
      remember: 'Mülakat sorularını cevaplamayı bitirdikten sonra, cevapları işe alım birimine göndermeyi unutmayın.',
      deleteHistory: 'Video mülakatı herkese açık bir bilgisayarda yapıyorsanız, lütfen tarama geçmişinizi temizlemeyi unutmayın. Bu, mülakatınızın güvenliği içindir.',
    },
    unpublished: {
      title: 'Mülakat henüz açılmadı',
      publishTime: publishTime => `Mülakat açılma zamanı: ${publishTime}`,
    },
  },
}
